import BaseClient from "./BaseClient";

export default class LedgerServiceClient extends BaseClient {
    constructor(billingDate = null, tenantId: string) {
        super(billingDate, tenantId, true, "ams");
    }
    public async getLedger(accountId: string): Promise<Ledger> {
        const response = await this.get(`/api/proxy/ams/ledger-service/account/${accountId}/ledger`);
        return await this.handleResponse<Ledger>(response);
    }

    public async getBillingPeriodBalance(accountId: string, billingPeriodId: number) {
        let response = await this.get(`/api/proxy/ams/ledger-service/account/${accountId}/billingperiod/${billingPeriodId}/balance`);
        return await this.handleResponse<any>(response);
    }

    public async getUnassignedEntries(accountId: string) {
        const response = await this.get(`/api/proxy/ams/ledger-service/account/${accountId}/billingperiod/unassigned-entries`);
        let transactionsResponse = await this.handleResponse<any>(response);
        let ledgerEntries = transactionsResponse.transactions.map(tx => {
            return {
                ledgerEntryId: tx.transactionId,
                ...tx
            }
        });

        return {
            ledgerEntries
        };
    }

    public async getBillingPeriodLedgerEntries(accountId: string, billingPeriodId: number) {
        const response = await this.get(`/api/proxy/ams/ledger-service/account/${accountId}/billingPeriod/${billingPeriodId}/entries`);
        return await this.handleResponse<any>(response);
    }

    public async getLedgerAllocations(accountId: string, transactionId: string) {
        const response = await this.get(`/api/proxy/ams/ledger-service/account/${accountId}/transaction/${transactionId}`);
        return await this.handleResponse<any>(response);
    }
}

export const useLedgerService = (billingDate = null, tenantId: string): LedgerServiceClient => {
    return new LedgerServiceClient(billingDate, tenantId);
};